import UserAvatar from '../atoms/userAvatar'
import logo from '../../assets/images/logo.svg'
import LogoutButton from '../atoms/logoutButton'

const TopNav = () => {
  return (
    <div className="z-10 fixed w-screen top-0 py-3 px-8 bg-bg/75 flex items-center justify-between border-b border-primary/[.15] backdrop-blur-sm">
      <img className="" alt="logo" src={logo} />
      <div className="flex items-center gap-4">
        <UserAvatar />
        <LogoutButton />
      </div>
    </div>
  );
};


export default TopNav
